import React, { useEffect } from "react";
import { Modal, Form, Select, Row, Col, Button, Avatar } from "antd";
import { MembreAffaireService } from "../../services/MembreAffaireService";
import Toast from "../../helpers/Toast";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import CustomFormItem from "../utils/form/CustomFormItem";
import style from "./MembreAffaireCreateForm.module.scss";
import UserService from "../../services/UserService";

const MembreAffaireCreateForm = ({ visible, onCreate, onCancel, affaire }) => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [creating, setCreating] = React.useState(false);
    const [validationErrors, setValidationErrors] = React.useState({});
    const [personnels, setPersonnels] = React.useState([]);

    const renderUserOption = (personnel) => (
        <div className={style.userOption}>
            <Avatar
                src={personnel.avatar}
                alt={personnel.name}
                className={style.userAvatar}
            >
                {personnel.name?.slice(0, 2)?.toUpperCase()}
            </Avatar>
            <span>{personnel.name}</span>
        </div>
    );

    useEffect(() => {
        UserService.getInstance().all().then((response) => {
            setPersonnels(response.data);
        }).catch((error) => {
            catchError(error);
        });
    }, []);

    const handleSave = (isRedirection) => {
        setCreating(true);
        form
            .validateFields()
            .then((values) => {
                values.affaire_id = affaire.id;
                MembreAffaireService.getInstance()
                    .create(values)
                    .then((response) => {
                        Toast.success(response.message);
                        form.resetFields();
                        onCreate(response.data);
                        onCancel?.();
                        if (isRedirection) {
                            navigate(`/membreaffaire/${response.data.uid}`);
                        }
                    })
                    .catch((error) => {
                        const errors = error.response.data;
                        if (errors.validation && Object.keys(errors?.errors).length) {
                            setValidationErrors(errors.errors);
                        } else {
                            catchError(error);
                        }
                    })
                    .finally(() => {
                        setCreating(false);
                    });
            })
            .catch(() => {
                setCreating(false);
            });
    };

    return (
        <Modal
            width={620}
            open={visible}
            onCancel={onCancel}
            title="Ajouter un collaborateur au dossier"
            className={style.memberModal}
            centered
            destroyOnClose
            footer={
                <div className={style.actionFooter}>
                    <Button
                        key="cancel"
                        onClick={onCancel}
                        className={style.secondaryButton}
                    >
                        Annuler
                    </Button>
                    <Button
                        key="save"
                        type="primary"
                        loading={creating}
                        onClick={() => handleSave(false)}
                        className={style.primaryButton}
                    >
                        Ajouter
                    </Button>
                </div>
            }
        >
            <div className={style.formSurface}>
                <Form
                    layout="vertical"
                    form={form}
                    name="createMembreAffaireForm"
                    initialValues={{
                    }}
                >
                    <Row gutter={24}>
                        <Col xs={24} md={24} lg={24}>
                            <CustomFormItem
                                label="Membres"
                                name="user_ids"
                                rules={[{ required: true, message: "Selectionner des membres" }]}
                                validationErrors={validationErrors}
                                setValidationErrors={setValidationErrors}
                            >
                                <Select
                                    size="large"
                                    mode="multiple"
                                    allowClear
                                    placeholder="Sélectionner des membres"
                                    showSearch
                                    optionFilterProp="full_name"
                                    maxTagCount="responsive"
                                    listHeight={280}
                                    popupClassName={style.memberSelectPopup}
                                    className={style.memberSelect}
                                    options={personnels.map((personnel) => ({
                                        value: personnel.id,
                                        label: renderUserOption(personnel),
                                        full_name: personnel.name
                                    }))}
                                />
                            </CustomFormItem>
                        </Col>
                    </Row>

                </Form>
            </div>
        </Modal>
    );
};

export default MembreAffaireCreateForm;

MembreAffaireCreateForm.propTypes = {
    visible: PropTypes.bool,
    onCreate: PropTypes.func,
    onCancel: PropTypes.func,
    affaire: PropTypes.object.isRequired,
};
